import React, {Component} from 'react';
import AdminTabs from './AdminTabs';
import {DataTable} from "react-data-components";
import userImage from '../../assets/128x128.jpg';
import api from '../../utils/api';
import moment from 'moment';
import {emojify} from 'react-emojione';
import 'emojione-picker/css/picker.css';
import Linkify from 'linkifyjs/react';
import jwt from 'jsonwebtoken';


function buildTable(data, columns) {
  const renderMapUrl =
    (val, row) =>
      <a href={`https://www.google.com/maps?q=${row['lat']},${row['long']}`}>
        Google Maps
      </a>;

  return (
    <DataTable
        keys="name"
        className="table-striped"
        columns={columns}
        initialData={data}
        useShowHideColumns={true}
        initialPageLength={10}
        initialSortBy={{ prop: 'Profiles[0].name', order: 'descending' }}
        pageLengthOptions={[10, 25, 50, 100]}
    />
  );
}



class AdminFlaggedCommentsView extends Component {
    
    
    constructor(props){
        super(props);
        
        this.state = {
            loaded: false,
            rowContent: null
        }
    }
    
    
    renderReporter = (val, row) => {
        
        let profile = null;
        
        let foundProfiles = this.props.users.filter(p => p.id === row.reportedBy[0].by);
        
        if(foundProfiles.length > 0){
            profile = foundProfiles[0];
            let avatar = userImage;
            if(profile.image){
                if(profile.image.indexOf('http') > -1){
                    avatar = profile.image;
                }else{
                    avatar = api.makeFileURL(profile.image, this.props.user.id);
                }
            }
        
        
            return (
                <span onClick={e => {
                    e.preventDefault();
                    this.setState({rowContent: row});
                }}>
                    <div className="user-and-question">
                        <div className="uq-avatar-wrap"><img src={avatar} alt="User Image"/> </div>
                        <div>
                            <h3>{`${profile.name} ${profile.lname}`}</h3>
                            <p>{profile.role}</p>
                        </div>
                    </div>
                </span>
            )
        }
    }
    
    renderReported = (val, row) => {

            let avatar = userImage;
            if(row.Profile.image){
                if(row.Profile.image.indexOf('http') > -1){
                    avatar = row.Profile.image;
                }else{
                    avatar = api.makeFileURL(row.Profile.image, this.props.user.id);
                }
            }
        
        
            return (
                <span onClick={e => {
                    e.preventDefault();
                    this.setState({rowContent: row});
                }}>
                    <div className="user-and-question">
                        <div className="uq-avatar-wrap"><img src={avatar}  alt="User Image" /> </div>
                        <div>
                            <h3>{`${row.Profile.name} ${row.Profile.lname}`}</h3>
                            <p>{row.Profile.role}</p>
                        </div>
                    </div>
                </span>
            )
        
    }
    
    renderDate = (val, row) => {
        return (
            <span>
                {moment(row.reportedBy[0].on).format('MMM DD YYYY [at] hh:mm A')}  
            </span>
        )
    }
    
    renderStatus = (val, row) => {
        if(row.reportedBy[row.reportedBy.length - 1].status === 'Pending'){
            return (
                <span>
                    <span className="text-danger">Pending</span>
                </span>
            )
        }else{
             return (
                <span>
                    <span className="text-success">Resolved</span>
                </span>
            )
        }
        
    }
    
    componentDidMount = () => {
        let command = jwt.sign({
            command: {
                type: 'GET_REPORTED_COMMENTS',
                profileId: this.props.user.user.Profile.id,
                token: this.props.user.id
            }}, '#&r7%+UbWU8Hc');
            if(this.props.socket.readyState){
                this.props.socket.send(command);
            }
    }
    
    componentDidUpdate = (props) => {
        if(this.props.socket.readyState && !this.state.loaded){
            
            this.setState({loaded: true}, () => {
                let command = jwt.sign({
                    command: {
                        type: 'GET_REPORTED_COMMENTS',
                        profileId: this.props.user.user.Profile.id,
                        token: this.props.user.id
                    }}, '#&r7%+UbWU8Hc');
                    
                    if(this.props.socket.readyState){
                        this.props.socket.send(command);
                    }
            })
            
            
            
        }
        
        if(props.flaggedComments !== this.props.flaggedComments){
            //buildTable(this.props.flaggedComments);
        }
        
    }
    
    render(){
        
        const columns = [
                            {title: 'Reporter', prop: 'id', className: 'v-middle', render: this.renderReporter},
                            {title: 'Reported', prop: 'id', className: 'v-middle', render: this.renderReported},
                            {title: 'Date Reported', prop: 'createdAt', className: 'v-middle', render: this.renderDate},
                            {title: 'Status', prop: 'id', className: 'v-middle', render: this.renderStatus}
                        ];
                        
        let {rowContent} = this.state;
        let splitLines = [];
        if(rowContent){
            splitLines = rowContent.content.split('\n').filter(l => l !== '');
        }
        
         const linkOptions = {
            target: '_blank'
        }
        
        return (
            <div className="chat-box">
                <AdminTabs view="flagged-comments" />
                <div className="chat-contents-wrapper" style={{background: '#111', paddingBottom: '50px'}}>
                    <div className="sp-top10" style={{paddingLeft: "20px", overflowY: "scroll", position: "relative", height: "100%", paddingRight: "20px"}}>
                       
                        <h2 className="font-22 text-white font-300 sm-bottom30">Flagged Comments</h2>
                        


                        <div className="tickets-table">
                                    {this.props.flaggedComments.length > 0 &&
                                    
                                        buildTable(this.props.flaggedComments, columns)
                                    }
                                </div>
                                    
                    </div>
                </div>
                
                
                <div className="modal fade in" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style={{zIndex: 9999, display: (this.state.rowContent) ? 'block' : 'none'}}>
                    <div className="modal-dialog modal-lg" role="document">

                        <div className="modal-content">

                            <div className="modal-body no-padding" style={{background: "#3c3840"}}>
                                <div className="clearfix">
                                    <div>
                                        <div className="modal-header">
                                            <button type="button" className="close" data-dismiss="modal" onClick={e => this.setState({rowContent: null})} aria-label="Close"><span aria-hidden="true">×</span></button>
                                            <h4 className="modal-title" id="myModalLabel">Reported Comment</h4>
                                        </div>
                                        <div className="modal-body no-padding subjectDeadlineContainer">
                                            
                                            <div className="chat-item chat-item-left modal-chat-item">
                                                <div className="chat-item-content">
                                                    {rowContent ?
                                                        
                                                        rowContent.Profile.image && rowContent.Profile.image.indexOf('http') > -1 ?
                                                        <img src={rowContent.Profile.image} className="chat-avatar" alt="User Image"/>
                                                    :
                                                        rowContent.Profile.image && rowContent.Profile.image.indexOf('http') === -1 ?
                                                            <img src={api.makeFileURL(rowContent.Profile.image, this.props.user.id)} className="chat-avatar" alt="User Image" />
                                                        :
                                                        <img src={userImage} className="chat-avatar" alt="User Image" />
                                                        
                                                        :
                                                        null
                                                    }
                                                    <div className="chat-box-wrap">
                                                        <div className="chat-box-wrapper">
                                                            {splitLines.map(l => {
                                                                return (
                                                                    <Linkify tagName="p" options={linkOptions}>{emojify(l.replace('{name}', rowContent.Profile.name), {output: 'unicode'})}</Linkify>    
                                                                )
                                                            })
                                                            }
                                                            {rowContent && 
                                                                rowContent.reportedBy &&
                                                                    rowContent.reportedBy.length > 0 &&
                                                                    rowContent.reportedBy[0].status !== 'Pending' &&
                                                                <span className="chat-box-meta">
                                                                    <span>{rowContent.Profile.name} - {rowContent.Profile.role}</span>
                                                                    <span>{moment(rowContent.createdAt).fromNow()}</span>
                                                                </span>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>


                                       
                                    </div>
                                   

                                </div>

                            </div>
                            {rowContent &&
                            rowContent.reportedBy &&
                            rowContent.reportedBy.length > 0 &&
                            rowContent.reportedBy[0].status !== 'solved' &&
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default" onClick={e => {
                                    e.preventDefault();
                                    this.setState({rowContent: null}, () => {
                                    
                                    let command = jwt.sign({
                                        command: {
                                            type: 'RESPOND_TO_REPORT',
                                            messageId: rowContent.id,
                                            response: 'keep',
                                            profileId: this.props.user.user.Profile.id,
                                            token: this.props.user.id
                                        }}, '#&r7%+UbWU8Hc');
                                        
                                        this.props.socket.send(command);
                                    });
                                    
                                }}>Keep</button>
                                <button type="button" onClick={e => {
                                    e.preventDefault();
                                    this.setState({rowContent: null}, () => {
                                    
                                    let command = jwt.sign({
                                        command: {
                                            type: 'RESPOND_TO_REPORT',
                                            messageId: rowContent.id,
                                            response: 'delete',
                                            profileId: this.props.user.user.Profile.id,
                                            token: this.props.user.id
                                        }}, '#&r7%+UbWU8Hc');
                                        
                                        this.props.socket.send(command);
                                    });
                                    
                                }} className="btn btn-danger">Delete Comment</button>
                            </div>
                            }
                        </div>

                    </div>
                </div>
           
            
            </div>
            )
    }
}

export default AdminFlaggedCommentsView;


// WEBPACK FOOTER //
// ./src/components/Chat/AdminFlaggedCommentsView.js